import script from "./Settings.vue?vue&type=script&setup=true&lang=ts"
export * from "./Settings.vue?vue&type=script&setup=true&lang=ts"

import "./Settings.vue?vue&type=style&index=0&id=d9a18dd6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9a18dd6"]])

export default __exports__